import { render, staticRenderFns } from "./AppQuestion10.vue?vue&type=template&id=68d7fa93&"
import script from "./AppQuestion10.vue?vue&type=script&lang=js&"
export * from "./AppQuestion10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports